import { render, staticRenderFns } from "./Newsletter.vue?vue&type=template&id=658a3858&scoped=true&"
import script from "./Newsletter.vue?vue&type=script&lang=ts&"
export * from "./Newsletter.vue?vue&type=script&lang=ts&"
import style0 from "./Newsletter.vue?vue&type=style&index=0&id=658a3858&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a3858",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\ladystern\\node_modules\\vue-loader\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('658a3858', component.options)
    } else {
      api.reload('658a3858', component.options)
    }
    module.hot.accept("./Newsletter.vue?vue&type=template&id=658a3858&scoped=true&", function () {
      api.rerender('658a3858', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Newsletter.vue"
export default component.exports